/**
 * DevExtreme (ui/date_box/ui.date_box.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var registerComponent = require("../../core/component_registrator");
var DateBoxMask = require("./ui.date_box.mask");
registerComponent("dxDateBox", DateBoxMask);
module.exports = DateBoxMask;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/date_box/ui.date_box.js
// module id = 1084
// module chunks = 0